export const mod = (num: number, modBy: number) => {
    return ((num % modBy) + modBy) % modBy;
};
